class Node {
  id: string;

  constructor(id: string) {
    this.id = id;
  }

  toJson(): Record<string, any> {
    return {
      id: this.id
    };
  }

  static fromJson(json: any): Node {
    return new Node(json.id);
  }
}

export default Node;